// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu5/Item.css
// module id = 2037
// module chunks = 0